<template>
  <div class="text-center p-3 rounded-lg bg-growth-10 transition-all duration-200 hover:bg-growth-25">
    <div
      class="font-bold tabular-nums"
      :class="[sizeClass, colorClass]"
    >
      {{ displayValue }}
    </div>
    <div class="text-xs text-growth-600 mt-1">{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: 'MetricCard',
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    format: {
      type: Function,
      default: null,
    },
    size: {
      type: String,
      default: 'md',
      validator: (val) => ['sm', 'md', 'lg'].includes(val),
    },
    color: {
      type: String,
      default: 'default',
      validator: (val) => ['default', 'info', 'success', 'warning', 'error', 'tangerine'].includes(val),
    },
  },
  computed: {
    displayValue() {
      if (this.format && typeof this.format === 'function') {
        return this.format(this.value)
      }
      return this.value
    },
    sizeClass() {
      const sizes = {
        sm: 'text-xl',
        md: 'text-2xl',
        lg: 'text-3xl',
      }
      return sizes[this.size] || sizes.md
    },
    colorClass() {
      const colors = {
        default: 'text-growth-900',
        info: 'text-growth-info',
        success: 'text-growth-success',
        warning: 'text-growth-warning',
        error: 'text-growth-error',
        tangerine: 'text-growth-tangerine',
      }
      return colors[this.color] || colors.default
    },
  },
}
</script>
